module.exports = __webpack_public_path__ + "static/media/description.15c7a2c9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/description.svg
// module id = 102
// module chunks = 0